import { ok, err, Result } from '@xlearn/common';
import { parseReal, realToString } from '../../api';
import { SchemaError, ErrorCode } from '../schema-engine';

export function getOptionalReal(value: number | '') {
  if (value === '') {
    return ok('');
  }

  return ok(realToString(value as number));
}

export function setOptionalRealRange(min: number, max: number) {
  return (current: number | '', value: string): Result<number | '', SchemaError> => {
    if (value === '') {
      return ok('');
    }

    const parsed = parseRealWithSchemaError(value, min, max);
    return parsed;
  };
}

export function setOptionalReal(current: number | '', value: string): Result<number | '', SchemaError> {

  if (value === '') {
    return ok('');
  }

  const parsed = parseRealWithSchemaError(value);
  return parsed;
}

export function parseRealWithSchemaError(value: string, min?: number, max?: number): Result<number, SchemaError> {

  const result = parseReal(value, min, max)
  if (result.success) {
    return ok(result.value)
  }

  switch (result.error) {
    case 'parse-error':
      return err(new SchemaError(ErrorCode.incorrectDataType, `Unable to parse real "${value}"`));
    case 'smaller-than-minimum':
      return err(new SchemaError(ErrorCode.incorrectDataType, `Real is smaller than minimum "${min}"`));
    case 'larger-than-maximum':
      return err(new SchemaError(ErrorCode.incorrectDataType, `Real is larger than maximum "${max}"`));
  }
}
